export default __webpack_public_path__ + "static/reflections-group-leaves-2-db95faf86dbec4424856fd560f79a9b5.png";